// extracted by mini-css-extract-plugin
export default {"WillBeAvailableLater":"WillBeAvailableLater_WillBeAvailableLater__B7OT6","content":"WillBeAvailableLater_content__rbE+s","icon":"WillBeAvailableLater_icon__566Ur"};